import React, { useMemo } from 'react';
import { Container, className, Row, Col, Heading } from 'design-system';
import { graphql } from 'gatsby';
import style from './styles.module.scss';
import ButtonComponent from '../ButtonComponent';

export function ServicesButtons({
    services,
    dark,
    wrapperClassName,
    desktopWidth,
    typeButton = 'secondary',
}) {
    return (
        <div
            className={`${style['buttons__wrapper']} ${
                wrapperClassName ? wrapperClassName : ''
            }`}>
            {services.map((service, index) => {
                return (
                    <div
                        key={index}
                        {...className(
                            `${style['button__wrapper']} ${
                                style[
                                    `button__wrapper--desktop-${
                                        desktopWidth ? desktopWidth : 'default'
                                    }`
                                ]
                            }`,
                        )}>
                        <ButtonComponent
                            dark={dark}
                            buttonClassName={style.button}
                            button={{
                                type: typeButton,
                                block: true,
                                label: service.title,
                                link: {
                                    slug: `${service?.page?.slug}${
                                        service.anchor
                                            ? `#${service?.anchor}`
                                            : ''
                                    }`,
                                },
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
}

function filterService(service) {
    return service && !!service.page && !service.hide;
}

export default function ServicesSection({
    title,
    serviceChilds,
    services,
    dark,
}) {
    const finalServiceChilds = useMemo(() => {
        return serviceChilds?.length
            ? serviceChilds.filter(filterService).map((sc) => {
                  let treeChildren = sc.treeChildren.filter(filterService);
                  if (!treeChildren?.length) {
                      treeChildren = [];
                      sc.treeChildren.forEach((sc) => {
                          treeChildren = [
                              ...treeChildren,
                              ...(sc?.treeChildren?.filter(filterService) ||
                                  []),
                          ];
                      });
                  }
                  return {
                      ...sc,
                      treeChildren,
                  };
              })
            : [];
    }, [serviceChilds]);

    const finalServices = useMemo(() => {
        return services?.length ? services.filter(filterService) : [];
    }, [services]);

    if (!finalServiceChilds?.length && !finalServices?.length) {
        return null;
    }

    return (
        <section
            data-datocms-noindex
            className={`${style.wrapper} ${
                dark ? style['wrapper--dark'] : ''
            }`}>
            <Container pt={{ xs: 10, lg: 20 }} pb={{ xs: 10, lg: 17 }}>
                <Row>
                    <Col offset={{ lg: 1 }} col={{ lg: 6, xl: 5, xxl: 4 }}>
                        <Heading tag="h2" className="h1 mb-5 mb-lg-10">
                            {title}
                        </Heading>
                    </Col>
                    {finalServiceChilds && (
                        <Col
                            offset={{ lg: 1 }}
                            col={{ lg: 10 }}
                            className={`d-lg-flex ${style['services--col']}`}>
                            {finalServiceChilds.map((service, i) => {
                                return (
                                    <div key={i} {...className('w-100')}>
                                        <div
                                            {...className(
                                                `mt-5 mt-lg-0 ${
                                                    style[
                                                        'button__first__wrapper'
                                                    ]
                                                }  ${
                                                    finalServiceChilds.length >
                                                    2
                                                        ? style['small']
                                                        : ''
                                                }`,
                                            )}>
                                            <ButtonComponent
                                                dark={dark}
                                                buttonClassName={style.button}
                                                button={{
                                                    type: 'secondary',
                                                    block: true,
                                                    label: service.title,
                                                    link: {
                                                        slug: service.page.slug,
                                                    },
                                                }}
                                            />
                                        </div>
                                        <ServicesButtons
                                            services={service.treeChildren}
                                            typeButton="link"
                                            wrapperClassName={`${
                                                style[
                                                    'services-treeChildren-button'
                                                ]
                                            }
                                       ${
                                           finalServiceChilds.length > 2
                                               ? style['small']
                                               : ''
                                       }
                                    `}
                                            dark={dark}
                                        />
                                    </div>
                                );
                            })}
                        </Col>
                    )}
                    {finalServices?.length ? (
                        <Col offset={{ lg: 1 }} col={{ lg: 10 }}>
                            <ServicesButtons
                                services={finalServices}
                                dark={dark}
                                desktopWidth="3"
                                wrapperClassName={style.servicesSingle}
                            />
                        </Col>
                    ) : null}
                </Row>
            </Container>
        </section>
    );
}

export const query = graphql`
    fragment DatoCmsServicesSection on DatoCmsServicesSection {
        title
        dark
        services {
            ...DatoCmsService
        }
        serviceChilds {
            ...DatoCmsService
            treeChildren {
                ...DatoCmsService
                treeChildren {
                    ...DatoCmsService
                }
            }
        }
    }

    fragment DatoCmsOtherServicesSection on DatoCmsOtherServicesSection {
        title
        services {
            ...DatoCmsService
        }
    }
`;
